import { ReactElement, ReactNode } from 'react';

import CareConnectSettingsProviderContext from 'features/care-connect-settings/contexts/care-connect-settings-provider-context';
import useCareConnectSettings from 'features/care-connect-settings/hooks/care-connect-settings';

type CareConnectSettingsProviderProps = {
  children: ReactNode;
};

const CareConnectSettingsProvider = ({ children }: CareConnectSettingsProviderProps): ReactElement => (
  <CareConnectSettingsProviderContext value={useCareConnectSettings()}>{children}</CareConnectSettingsProviderContext>
);

export default CareConnectSettingsProvider;
